import { PayorderParseReportDto, PayorderImportReportDto, CreatePayOrderImportSessionDto } from '@sr/dto';
import { plainToInstance } from 'class-transformer';
import { useState } from 'react';
import { authorizedRequest } from 'shared/api/axios';

export const useImport = () => {
  const [loading, setLoading] = useState(false);

  async function uploadAndParse(data: any) {
    setLoading(true);

    return authorizedRequest<CreatePayOrderImportSessionDto, PayorderImportReportDto>(
      'accounting/payorders/import',
      'POST',
      data
    )
      .then(response => plainToInstance(PayorderParseReportDto, response, { enableImplicitConversion: true }))
      .finally(() => setLoading(false));
  }

  return {
    uploadAndImport: uploadAndParse,
    loading
  };
};
